<template>
  <v-card class="regions-search__bar px-4" :class="{ '!wd-z-15': isSearchNavigationShown }">
    <v-row v-if="showCategoryAndNow" class="bar__row" no-gutters>
      <v-col class="d-flex py-3" cols="2/3">
        <!-- 享樂類別 -->
        <FilterBottomSheet
          v-model="categoryMenu"
          :filter-value="selectedCategory.id || 0"
          :filter-options="categoriesOptions"
          :icon-path="'funnow-icon.svg'"
          :button-text="selectedCategory.name || $t('filter_category')"
          :key-value="['categoryID']"
          :is-branch-card-mode="isBranchCardMode"
          :title="$t('filter_category')"
          content-type="list"
          @confirm-btn="onClickCategory"
        />
      </v-col>
      <v-divider class="mx-1 my-4" vertical />
      <v-col class="d-flex py-3" cols="auto">
        <v-btn
          class="filter__btn mr-3 wd-text-omd"
          :class="{ selected: filterNow.activated }"
          min-width="100"
          height="40"
          variant="text"
          @click="clickNowFilter"
        >
          <FunnowSvgIcon class="mr-2" max-width="24" :image-path="'flash-icon_current.svg'" />
          {{ $t('filter_now') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="bar__row" no-gutters>
      <v-col class="d-flex py-3">
        <!-- 日期 -->
        <FilterBottomSheet
          ref="dateFilter"
          v-model="dateMenuValue"
          :actived="filterDate.activated"
          :filter-key="'date'"
          :filter-value="filterDate.value || ['', []]"
          :filter-options="filterDate.options"
          :icon-path="'calendar-icon.svg'"
          :button-text="filterDate.text || $t('filter_date')"
          :day-mode="filterDate.dayMode"
          :key-value="filterDate.keyValue"
          :current-filter="currentFilter"
          :total-count="totalCount"
          :is-debounce="true"
          :clear-btn="true"
          :title="$t('available_booking_time')"
          :is-branch-card-mode="isBranchCardMode"
          content-type="date-picker"
          @confirm-btn="updateFilterCondition"
        />
      </v-col>
      <v-divider class="mx-1 my-4" vertical />
      <v-col class="d-flex py-3">
        <!-- 時間 -->
        <FilterBottomSheet
          :actived="filterTime.activated"
          filter-key="time"
          :filter-value="filterTime.value"
          icon-path="clock.svg"
          :button-text="filterTime.text || $t('all_time')"
          :key-value="filterTime.keyValue"
          :current-filter="currentFilter"
          :total-count="totalCount"
          :is-debounce="true"
          :clear-btn="true"
          :title="$t('all_time')"
          :is-branch-card-mode="isBranchCardMode"
          content-type="time-picker"
          @confirm-btn="updateFilterCondition"
        />
      </v-col>
      <v-divider class="mx-1 my-4" vertical />
      <v-col class="d-flex py-3">
        <!-- 人數 -->
        <FilterBottomSheet
          v-model="headCountMenuValue"
          :actived="filterHeadCount.activated"
          :disabled="disabledHeadCount"
          :filter-key="'headcount'"
          :filter-value="filterHeadCount.value"
          :filter-options="filterHeadCount.options"
          :icon-path="'member-icon.svg'"
          :button-text="filterHeadCount.text || $t('filter_pax')"
          :key-value="filterHeadCount.keyValue"
          :current-filter="currentFilter"
          :total-count="totalCount"
          :is-debounce="true"
          :title="$t('filter_pax')"
          :is-branch-card-mode="isBranchCardMode"
          content-type="list"
          @confirm-btn="updateFilterCondition"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex py-3" cols="auto">
        <v-text-field
          v-model="inputKeyword"
          class="search-input text__overflow wd-h-8 wd-w-full"
          :placeholder="searchPlaceholder"
          autocomplete="off"
          color="orange50"
          variant="solo"
          flat
          density="compact"
          readonly
          hide-details
          @click="openSearchNavigation"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="pb-3" cols="12" sm="auto">
        <v-btn
          class="search__btn text-white"
          min-width="40"
          width="100%"
          height="40"
          color="orange50"
          variant="flat"
          block
          @click="pathToSearchResult"
        >
          {{ $t('filter_result_apply_button') }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- 側邊搜尋 -->
    <SearchNavigation
      :search-keyword="inputKeyword"
      :placeholder="searchPlaceholder"
      :popular-keywords="effectivePopularKeywords"
      :history-key-words="effectiveHistoryKeyWords"
      @submit-keyword="inputSearchKeywords"
    />
  </v-card>
</template>

<script>
import regionFilterSetting from '@/composition/region-filter-setting'
import { useGtm, useGtmSearchQuerySent } from '@/composition/useGtm'
import { GtmEventMap } from '@/view-models/gtm'

import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
import FilterBottomSheet from '@/components/bottomSheet/filter-bottom-sheet.vue'
const SearchNavigation = defineAsyncComponent(() => import('@/components/search/search-navigation.vue'))

export default defineComponent({
  name: 'RegionsSearchBarMobile',
  components: {
    FilterBottomSheet,
    SearchNavigation,
    FunnowSvgIcon,
  },
  props: {
    allRegions: { type: Array, default: () => [] },
    region: { type: Object, default: () => ({}) },
    categories: { type: Array, default: () => [] },
    dataCount: { type: Number, default: 0 },
    searchParams: { type: Object, default: () => ({}) },
    searchKeyWord: { type: String, default: '' },
    searchKeywordsOfRegion: { type: Array, default: () => [] },
    historyKeyWords: { type: Array, default: () => [] },
    headcountOptions: { type: Array, default: () => [] },
    isBranchCardMode: { type: Boolean, default: true },
    showCategoryAndNow: { type: Boolean, default: true },
  },
  emits: ['updateFilterData', 'updateSearchKeyword'],
  setup(props) {
    const { sendGtmEvent } = useGtm()
    const { keywordSource, fireSearchQuerySentEvent } = useGtmSearchQuerySent()
    const {
      filterNow,
      filterDate,
      filterTime,
      filterHeadCount,
      currentFilter,
      selectedCategory,
      initSearchBar,
      setSearchKeyWord,
      updateCondition,
      onClickCategory,
      clickNowFilter,
      syncFiltersFromStore,
    } = regionFilterSetting(props)
    const localePath = useLocalePath()

    return {
      sendGtmEvent,
      keywordSource,
      fireSearchQuerySentEvent,
      filterNow,
      filterDate,
      filterTime,
      filterHeadCount,
      currentFilter,
      selectedCategory,
      initSearchBar,
      setSearchKeyWord,
      updateCondition,
      onClickCategory,
      clickNowFilter,
      syncFiltersFromStore,
      localePath,
    }
  },
  data() {
    return {
      regionMenu: false,
      categoryMenu: false,
      dateMenuValue: false,
      headCountMenuValue: false,
      filters: { components: [] },
      inputKeyword: this.searchKeyWord || '',
      totalCount: this.dataCount || 0,
    }
  },
  computed: {
    loggedInUser() {
      return this.$auth.user
    },
    regionsOptions() {
      return this.allRegions.map(region => {
        return { title: region.name, value: region.region_id }
      })
    },
    categoriesOptions() {
      return this.categories.map(category => {
        return { title: category.name, value: category.id }
      })
    },
    searchPlaceholder() {
      return this.$t('search_region_placeholder', { region: this.region.name })
    },
    isSearchNavigationShown() {
      return this.$store.state.searchNavigation
    },
    storeSearchKeyword() {
      return this.$store.getters['search/searchKeyword']
    },
    storeFilters() {
      return this.$store.getters['filter/filters']
    },
    isListPage() {
      const routeName = this.$route?.name
      return checkIfRegionCategoriesPage(routeName) || checkIfRegionThemesPage(routeName)
    },
    disabledHeadCount() {
      if (this.isListPage) return false
      return this.filterHeadCount.options.length <= 0
    },
    effectivePopularKeywords() {
      if (this.isListPage) return this.$store.getters['search/searchKeywordsOfCategory']
      return this.searchKeywordsOfRegion
    },
    effectiveHistoryKeyWords() {
      if (this.isListPage) return this.$store.getters['search/searchKeywordsOfHistory']
      return this.historyKeyWords
    },
  },
  watch: {
    headcountOptions: {
      handler(newOptions) {
        if (this.isListPage && newOptions && newOptions.length > 0) {
          Object.assign(this.filterHeadCount, { options: newOptions })
        }
      },
    },
    storeFilters(newFilters) {
      if (this.isListPage && this.filterDate.options && this.filterDate.options.length > 0) {
        this._syncFiltersFromStore(newFilters)
      }
    },
    dataCount(newCount) {
      this.totalCount = newCount
    },
    searchKeyWord(newKeyWord) {
      this.inputKeyword = newKeyWord
    },
    storeSearchKeyword(newVal) {
      if (this.isListPage) {
        this.inputKeyword = newVal || ''
      }
    },
  },
  created() {
    this.initSearchBar()
    if (this.isListPage) {
      this.inputKeyword = this.storeSearchKeyword || ''
      const unwatch = this.$watch(
        () => this.filterDate.options,
        newOptions => {
          if (newOptions && newOptions.length > 0) {
            unwatch()
            // Inject headcount options from parent (category-info-sheet) after initFilterChips() runs
            if (this.headcountOptions && this.headcountOptions.length > 0) {
              Object.assign(this.filterHeadCount, { options: this.headcountOptions })
            }
            this._syncFiltersFromStore(this.storeFilters)
          }
        },
        { immediate: true }
      )
    }
  },
  methods: {
    async handleRedirectToRegion({ params }) {
      const regionId = params.regionID
      const selectedRegion = this.regionsOptions.find(e => e.value === regionId)
      const event = {
        event: GtmEventMap.REGION_CHANGED,
        payload: {
          'To Region ID': regionId,
          'To Region Name': selectedRegion.title,
        },
      }

      if (regionId && regionId !== this.region.id) {
        this.sendGtmEvent(event, false)
        if (this.loggedInUser) {
          this.sendGtmEvent(event, true)
          await this.$store.dispatch('authentication/updateMemberRegion', { regionId, userInfo: this.loggedInUser })
        }

        this.$router.push(this.localePath({ name: 'regions-rid', params: { rid: regionId } }))
      }
    },
    updateFilterCondition({ params, filterKey, activated, totalCount }) {
      this.updateCondition({ params, filterKey, activated })
      this.totalCount = totalCount
      // Sync filter/filters store so other components (category-info-sheet) stay in sync
      if (filterKey === 'date') {
        this.$store.dispatch('filter/setFilters', { ...params, filter_time: null })
      } else {
        this.$store.dispatch('filter/setFilters', { ...params })
      }
      this.$emit('updateFilterData', { totalCount, filters: params })
    },
    _syncFiltersFromStore(filters) {
      this.syncFiltersFromStore(filters)
    },
    openSearchNavigation() {
      this.$store.dispatch('setSearchNavigation', true)
    },
    inputSearchKeywords({ keyword, keywordSource, isEnter }) {
      this.inputKeyword = keyword
      this.keywordSource = keywordSource || ''
      this.setSearchKeyWord(keyword)
      if (this.isListPage) {
        // 列表頁選完 keyword 就立刻搜尋，所以在這裡 fire event
        this.fireSearchQuerySentEvent(this.buildSearchEventOptions({ keyword, isEnter }))
        this.$store.dispatch('search/setSearchKeyword', keyword)
      } else {
        // 首頁只更新 keyword，event 在使用者點搜尋按鈕時由 pathToSearchResult 送出
        this.updateSearchKeywords(keyword)
      }
    },
    updateSearchKeywords(keyword) {
      this.$emit('updateSearchKeyword', keyword)
    },
    pathToSearchResult() {
      const {
        starttime,
        endtime,
        filter_times: filterTimes,
        limit: headcount,
        filter_time: filterTime,
        filter_keyword: filterKeyword,
      } = this.currentFilter

      // PM: 點擊「套用」視同 Enter 送出搜尋，enter 統一為 true
      this.fireSearchQuerySentEvent(this.buildSearchEventOptions({ keyword: filterKeyword, isEnter: true }))

      // On list pages (categories/themes), dispatch to store so useRegionSearchNavigation
      // handles in-place re-fetch — same flow as components/search/search-bar.vue doSearch()
      if (this.isListPage) {
        if (filterKeyword) {
          this.$store.dispatch('search/saveHistorySearchKeyword', filterKeyword)
        }
        this.$store.dispatch('search/setSearchKeyword', filterKeyword || '')
        return
      }

      // Homepage: navigate to category/search page with full filter query
      const regionID = this.region.id
      const categoryID = this.selectedCategory.id

      const searchQuery = {
        starttime,
        endtime,
        filter_times: filterTimes,
        limit: headcount,
        filter_time: filterTime,
        filter_keyword: filterKeyword || undefined,
      }
      if (categoryID) {
        this.$router.push(
          this.localePath({
            name: 'regions-rid-categories-id',
            params: { rid: regionID, id: categoryID },
            query: { ...searchQuery },
          })
        )
      } else {
        this.$router.push(this.localePath({ name: 'regions-rid-search', params: { rid: regionID }, query: { ...searchQuery } }))
      }
    },
    buildSearchEventOptions({ keyword, isEnter = false }) {
      return {
        keyword,
        isEnter,
        sourceName: this.$store.getters['category/firstLevelCategory']?.name || '',
        isListPage: this.isListPage,
        isEmbeddedSearchBarVisible: this.$store.getters.isEmbeddedSearchBarVisible,
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.regions-search__bar {
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.16), 0px 9px 28px rgba(0, 0, 0, 0.1) !important;

  .bar__row {
    border-bottom: 1px solid $gray40;
  }

  .filter__btn {
    padding: 0 12px;
    width: 100%;

    &.selected {
      color: $orange50;
    }
  }

  .search-input {
    min-width: 178px;
  }

  .search__btn {
    font-size: 17px;
  }
}
</style>
<style lang="scss">
.text__overflow {
  input {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
